export default __webpack_public_path__ + "static/media/Quay.a3c7b48e.png";